export class Sprite {
  constructor(char = '?', fg = '#fff', bg = '#000') {
    this.char = char;
    this.fg = fg;
    this.bg = bg;
  }
}
